import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/react-hot-toast/dist/index.mjs");
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/Layout/mentors/hero.js");
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/ui/animation/faideIn.js");
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/ui/icons/blink.css")